import $ from 'static/script/libs/jquery';
import { component } from 'flightjs';
import WithAjax from 'static/script/app/data/with-ajax';
import History from 'static/script/utils/history';
import InitData from 'static/script/app/data/init-data';

function Pagination() {
    this.defaultAttrs({
        cardListContainer: '[data-card-list-container]',
        pagination: '.search-pagination-bottom',
        paginationTop: '.search-pagination-top',
        items: '.card-list a',
        next: '[data-pagination-show-more]',
        first: '[rel=first]',
        previous: '[data-pagination-prev]'
    });

    this._next = function(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this._loadPage(evt.target, this._afterNext);
    };

    this._previous = function(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this._loadPage(evt.target, this._afterPrev);
    };

    this._loadPage = function(targetElement, onSuccess) {
        let target = $(targetElement).closest('a');
        let href = target.attr('href');
        let onError = function() {
            target
                .addClass('error')
                .html('Ett fel uppstod. <span>Försök igen.</span>');
        };

        let updatePageState = function() {
            this._forceReflowIfAndroid();
            let initData = InitData.current();
            this.trigger('ui:navigation:after-page-change', initData);
            History.replaceState({}, initData.title, href);
        };

        target
            .addClass('loading')
            .removeClass('error')
            .html('Hämtar...');

        this._get({
            url: href,
            dataType: 'html',
            headers: { 'x-push-state-request': 'true' },
            success: onSuccess.bind(this, href),
            error: onError,
            requestId: 'search-pagination'
        }).done(updatePageState.bind(this));
    };

    this._forceReflowIfAndroid = function() {
        // samsung galaxy tab and s2 need this to render properly, otherwise appended search results cannot be scrolled down to
        if (window.Feature._getUserAgent().indexOf('Android') >= 0) {
            let forceReflow = $('<div />');
            forceReflow.addClass('force-reflow').appendTo('body');

            setTimeout(function() {
                forceReflow.remove();
            }, 200);
        }
    };

    this._afterNext = function(href, html) {
        let $html = $(html);
        let initData = InitData.setFromHtml(html);

        $html.find('a').data('origin', href);
        this.select('cardListContainer').append(
            $html.find(this.attr.cardListContainer).html()
        );
        this.select('pagination').replaceWith(
            $html.find('.search-pagination-bottom')
        );

        this.trigger('ui:search-result:after-pagination', {
            pageIndex: initData.pageIndex,
            direction: 'next'
        });
    };

    this._afterPrev = function(href, html) {
        let $html = $(html);
        let initData = InitData.setFromHtml(html);

        $html.find('a').data('origin', href);
        let firstElement = this.select('cardListContainer')
            .children()
            .first();
        let firstElementPosition = firstElement.position().top;

        this.select('cardListContainer').prepend(
            $html.find(this.attr.cardListContainer).html()
        );
        this.select('paginationTop').replaceWith(
            $html.find('.search-pagination-top')
        );
        this.select('pagination').replaceWith(
            $html.find('.search-pagination-bottom')
        );

        window.scrollTo(0, firstElement.position().top - firstElementPosition);

        this.trigger('ui:search-result:after-pagination', {
            pageIndex: initData.pageIndex,
            direction: 'prev'
        });
    };

    this._updateUrl = function(evt) {
        let $link = $(evt.target).closest('a');
        let origin = $link.data('origin');

        if (origin) {
            History.replaceState({}, document.title, origin);
        }
    };

    this._scrollToTop = function(evt) {
        if (!this._isOnFirstPage) {
            return;
        }
        evt.preventDefault();

        $(window).scrollTop(0);

        History.replaceState({}, null, this.select('first').attr('href'));
    };

    this.after('initialize', function() {
        this.on('click', {
            next: this._next,
            previous: this._previous,
            first: this._scrollToTop,
            items: this._updateUrl
        });

        this._isOnFirstPage = this.select('previous').length === 0;
        this.$node.find('a').data('origin', window.location.href);
    });
}

export default component(Pagination, WithAjax);
